<template>
    <img loading="lazy" v-bind="lazyImageProps" :class="activeLogoCheck" :src="customerIcon" id="customerlogoID" alt="Logo" />
</template>

<script>
//const CUSTOMER_ICON_REQUEST = "CUSTOMER_ICON_REQUEST";

import Snotify, {SnotifyPosition} from 'vue-snotify'
import Vue from "vue"

Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.leftTop,
  }
})

export default {
    name: "customerIcon",
    props: {
        customerid: String,
        customername: String,
        enabled: Number
    },
    components: {},
    computed: {
        activeLogoCheck(){
            if(this.enabled == 1){ //If it's enabled, or the value's somehow missing, assume active (May be due to viewing as customer)
                return "activeElement"
            } else{
                return "inactiveElement"
            }
        },
        customerIcon(){
            let customerLogo = this.$store.getters.getCustomerIcon(this.customerid)
            if(customerLogo && customerLogo.length > 0){
                return this.$store.getters.getCustomerIcon(this.customerid)
            } else { //Placeholder for missing customer logo
                return require("@/assets/images/building.png")
            }  
        },
    },
    data() {
        return {
            lazyImageProps: {
                blank: true,
                blankColor: '#bbb',
                offset: 360,
                show: false
            }
        }
    },
    filters: {},
    methods: {
    },
}
</script>